export default {"src":"/_next/static/media/usdc.488ae977.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};